import Dataman from 'App/Dataman';
import { checkExpiration } from 'App/utils/Helpers';

export default {
  data() {
    return {
      isLoadCounters: false,
    };
  },
  computed: {
    cachedCounters() {
      return this.$store.getters || {};
    },
    isCountersExpired() {
      const { lastUpdate } = this.$store.state.countersCache;
      return checkExpiration(lastUpdate);
    },
  },
  methods: {
    async updateCounters(categoryId, nocache = false) {
      if (!this.isCountersExpired && !nocache) {
        return this.cachedCounters;
      }
      this.isLoadCounters = true;
      return Dataman.getAllCounters(categoryId)
        .then(
          (data) => {
            const counters = Object.fromEntries(data.map((el) => [el.category, el.value]));
            this.$store.dispatch('setCounters', counters);
            return counters;
          },
          () => {
            return this.cachedCounters;
          }
        )
        .finally(() => {
          this.isLoadCounters = false;
        });
    },
  },
};
